export const EditModes = {
    PickComponentMode: 'pick-component-mode',
    InteractionMode: 'interaction-editing-mode',
    GridEditingMode: 'grid-editing-mode',
    GridSliceMode: 'grid-slice-mode',
    TextEditingMode: 'text-editing-mode',
};
//# sourceMappingURL=modes.js.map